// @flow
const imageHelpers = require('./view_helpers/image');
const diamondHelpers = require('./view_helpers/diamond');

export default { ...imageHelpers, ...diamondHelpers };
